import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, theme } from '@marriott/mi-ui-library-shop';
import { baseVariables } from '@marriott/mi-ui-library';

export const StyledMapContainerDiv = styled.div`
  ${rtl`
  &.chat-map-container {
    height: 100%;
    position: relative;
    
    .list-cta-css {
      height: 100%;
      position: relative;
    }

    /* Chat-specific positioning for list button container */
    .map-button-container {
      position: absolute !important;
      bottom: ${toRem(16)} !important;
      left: 50% !important;
      transform: translateX(-50%) !important;
      top: auto !important;
      right: auto !important;
      z-index: 9 !important;
      width: auto !important;
      max-width: none !important;
      padding: 0 !important;
      margin: 0 !important;
      
      /* Override Bootstrap container class */
      &.container {
        max-width: none !important;
        padding-left: 0 !important;
        padding-right: 0 !important;
        margin-left: 0 !important;
        margin-right: 0 !important;
      }

      /* Mobile - safe area inset bottom */
      @media (max-width: 767px) {
        bottom: env(safe-area-inset-bottom) !important;
        padding-bottom: ${toRem(16)} !important;
      }
    }

    /* Chat-specific styling for map-list-toggle-button */
    .map-list-toggle-button-chat {
      background: var(--color-set-button-primary-bg-color, #1c1c1c) !important;
      color: var(--color-set-button-primary-fg-color, #ffffff) !important;
      border-radius: var(--border-radius-button-border-radius, 52px) !important;
      box-shadow: 0px 7px 20px 0px rgba(0, 0, 0, 0.25) !important;
      font-family: var(--typography-subtitle-font-family, 'Swiss721_BT:Medium', sans-serif) !important;
      font-size: ${toRem(16)} !important;
      font-weight: ${theme.fonts['fontWeightMedium']} !important;
      line-height: 1 !important;
      padding: var(--general-spacer-02, ${toRem(12)}) var(--general-spacer-03, ${toRem(16)}) !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      gap: var(--general-spacer-01, ${toRem(4)}) !important;
      border: none !important;
      min-height: auto !important;
      height: auto !important;
      white-space: nowrap !important;
      min-width: ${toRem(100)} !important;
      
      .icon {
        margin-right: 0 !important;
        font-size: ${toRem(16)} !important;
        color: var(--color-set-button-primary-fg-color, #ffffff) !important;
        width: ${toRem(16)} !important;
        height: ${toRem(16)} !important;
      }

      &:hover {
        background-color: ${theme.color['dark-gray-10'] || '#333333'} !important;
        box-shadow: 0 ${toRem(9)} ${toRem(25)} 0 rgba(0,0,0,0.3) !important;
        transform: translateY(-1px);
      }

      &:active {
        background-color: ${theme.color['black'] || '#0a0a0a'} !important;
        box-shadow: 0 ${toRem(5)} ${toRem(15)} 0 rgba(0,0,0,0.35) !important;
        transform: translateY(0);
      }

      
    }
  }
  
  &.map-loader-full {
    height: ${toRem(500)};
    background-color: ${theme.color['light-gray-3']};
    width: 100%;

    .loader-container {
      height: 100%;
    }
  }

  .map-width-full {
    width:100vw !important;
  }
  position: relative;
  width:calc(100vw - 24rem);
  @media only ${theme.mediaQuery.tabletMax} {
    width:100vw;
   }
  @media only ${theme.mediaQuery.allMobiles} {
    width:100vw;
  }

  .list-cta-css {
    position: relative;
  }

  .list-button-container {
    position: absolute;
    top: ${toRem(24)};
    right: ${toRem(16)};
    @media only ${theme.mediaQuery.allTablets} {
      right: ${toRem(32)};
    }
    @media ${baseVariables.mediaQuery.lg} {
      display: none;
    }
    @media ${baseVariables.mediaQuery.xl} {
      display: none;
    }
    z-index:1;
    .map-button {
      border-radius: ${toRem(50)};
      height: ${toRem(40)};
      font-size: ${toRem(16)};
      font-weight: ${theme.fonts['fontWeightMedium']};
      box-shadow: ${toRem(0)} ${toRem(5)} ${toRem(16)} rgba(0, 0, 0, 0.5);
      display: flex;
      font-family: ${theme.fontFamily.swiss};
      align-items: center;
      justify-content: center;
      padding: ${toRem(9)} ${toRem(21)};
      background-color: ${theme.color['white']};
      .icon {
        margin-right: ${toRem(6)};
        height: auto;
        width: auto;
        font-size: ${toRem(20)};
        font-style: normal;
      }
      .icon-map {
        margin-right: ${toRem(5)};
      }
      &:focus {
        border: ${toRem(1)} solid ${theme.color['black']};
      }
    }
  }

  .gm-svpc img {
    height: 20px !important;
    box-shadow: 0 0 0 rgb(0 0 0 / 0.2);
  }



  .gm-control-active {
        &[title='Zoom in'] {
    border-radius: 50% !important;
    box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
    height: ${toRem(30)} !important;
    width: ${toRem(30)} !important;
    margin-left: ${toRem(2)} !important;
    margin-bottom: ${toRem(7)} !important;
        }
    &[title='Zoom out'] {
      border-radius: 50% !important;
    box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
    height: ${toRem(30)} !important;
    width: ${toRem(30)} !important;
    margin-left: ${toRem(2)} !important;
    margin-bottom: ${toRem(6)} !important;
      top: ${toRem(2)} !important;
    }
  }

.gm-control-active>img {
    width: ${toRem(12)} !important;
}


 div[data-control-height="81"]>div{
   border-radius: ${toRem(25)} !important;
    width: ${toRem(32)} !important;
    height:${toRem(69)} !important;
     box-shadow: 0 4px 20px 0 rgba(0,0,0,0.6);
 }
  div[data-control-height="81"]>div>div{
height:0px !important
 }
  .gm-svpc {
    border-radius: 50% !important;
    height: ${toRem(30)} !important;
    width: ${toRem(30)} !important;
     box-shadow: 0 4px 20px 0 rgba(0,0,0,0.6);
    background-color: #fff !important;
    margin-top:${toRem(25)};
  }

  .gm-ui-hover-effect {
    display: none !important;
  }

  @media only screen and (max-width: 1000px) {
    .gm-svpc,
    .gm-svpc ~ .gmnoprint,
    .gm-control-active.gm-fullscreen-control {
      display: none;
    }
  }
  @media only ${theme.mediaQuery.allMobiles} {
    .list-button-container{
      position:fixed !important;
      top: unset;
      right:unset;
      width:100%;
      bottom:env(safe-area-inset-bottom);
    }
    .map-button{
      margin-left:auto;
      margin-right:auto;
      margin-bottom:${toRem(24)};
    }
  }
  `}
`;
